import { render, staticRenderFns } from "./ConnectPaxos.vue?vue&type=template&id=6bf87b22&"
import script from "./ConnectPaxos.vue?vue&type=script&lang=js&"
export * from "./ConnectPaxos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports